import React from 'react';
import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

const TableSkeleton = () => {
  // Generate an array of 5 rows for the skeleton
  const rows = Array(5).fill(null);

  return (
    <Card className="overflow-hidden">
      {/* Header Section */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 p-4 border-b">
        <Skeleton className="h-5 w-48" />
        <div className="flex items-center gap-2">
          <Skeleton className="h-5 w-16" />
          <Skeleton className="h-9 w-48" />
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          {/* Table Header */}
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3"><Skeleton className="h-4 w-20" /></th>
              <th className="px-4 py-3"><Skeleton className="h-4 w-24" /></th>
              <th className="px-4 py-3"><Skeleton className="h-4 w-16" /></th>
              <th className="px-4 py-3"><Skeleton className="h-4 w-16" /></th>
              {/* T1-T4 */}
              {Array(4).fill(null).map((_, i) => (
                <th key={`t${i+1}`} className="px-2 py-3">
                  <Skeleton className="h-4 w-8 mx-auto" />
                </th>
              ))}
              {/* T5-T8 */}
              {Array(4).fill(null).map((_, i) => (
                <th key={`t${i+5}`} className="px-2 py-3">
                  <Skeleton className="h-4 w-8 mx-auto" />
                </th>
              ))}
              {/* T.Tot, 1st, Win, P1, P2 */}
              {Array(5).fill(null).map((_, i) => (
                <th key={`extra${i}`} className="px-2 py-3">
                  <Skeleton className="h-4 w-8 mx-auto" />
                </th>
              ))}
            </tr>
          </thead>

          {/* Table Body */}
          <tbody className="bg-white divide-y divide-gray-200">
            {rows.map((_, rowIndex) => (
              <tr key={rowIndex} className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                <td className="px-4 py-3"><Skeleton className="h-5 w-24" /></td>
                <td className="px-4 py-3"><Skeleton className="h-5 w-32" /></td>
                <td className="px-4 py-3"><Skeleton className="h-5 w-12" /></td>
                <td className="px-4 py-3"><Skeleton className="h-5 w-8" /></td>
                {/* T1-T4 cells */}
                {Array(4).fill(null).map((_, i) => (
                  <td key={`t${i+1}`} className="px-2 py-3">
                    <div className="flex flex-col items-center">
                      <Skeleton className="h-5 w-8 mb-1" />
                      <Skeleton className="h-3 w-12" />
                    </div>
                  </td>
                ))}
                {/* T5-T8 cells */}
                {Array(4).fill(null).map((_, i) => (
                  <td key={`t${i+5}`} className="px-2 py-3">
                    <div className="flex flex-col items-center">
                      <Skeleton className="h-5 w-8 mb-1" />
                      <Skeleton className="h-3 w-12" />
                    </div>
                  </td>
                ))}
                {/* Total Unique Tips */}
                <td className="px-2 py-3">
                  <Skeleton className="h-5 w-8 mx-auto" />
                </td>
                {/* First Place */}
                <td className="px-2 py-3">
                  <Skeleton className="h-5 w-8 mx-auto" />
                </td>
                {/* Win/Place Prices */}
                {Array(3).fill(null).map((_, i) => (
                  <td key={`price${i}`} className="px-2 py-3">
                    <Skeleton className="h-6 w-12 mx-auto rounded-full" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
};

export default TableSkeleton;
